import { render, staticRenderFns } from "./SideInfo.vue?vue&type=template&id=4df4feee&scoped=true&"
import script from "./SideInfo.vue?vue&type=script&lang=js&"
export * from "./SideInfo.vue?vue&type=script&lang=js&"
import style0 from "./SideInfo.vue?vue&type=style&index=0&id=4df4feee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4feee",
  null
  
)

export default component.exports